// extracted by mini-css-extract-plugin
export default {"chart":"trend-chart_chart__N2vKm"};